var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-tasks"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks",
    clipPath: "url(#clip-tasks)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-41.863 -464.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(45.123 468.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M46.468,471.562H73.356a1.345,1.345,0,0,0,0-2.689H46.468a1.345,1.345,0,0,0,0,2.689Z",
    transform: "translate(-45.123 -468.873)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M48.1,475.075a1.346,1.346,0,0,0,1.347,1.345h25.2a1.346,1.346,0,0,0,0-2.691h-25.2A1.348,1.348,0,0,0,48.1,475.075Z",
    transform: "translate(-42.504 -464.597)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M71.427,479.931a1.344,1.344,0,0,0-1.345-1.345H46.468a1.346,1.346,0,0,0,0,2.691H70.082A1.346,1.346,0,0,0,71.427,479.931Z",
    transform: "translate(-45.123 -460.32)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M74.547,484.788a1.344,1.344,0,0,0-1.345-1.345H51.074a1.345,1.345,0,0,0,0,2.689H73.2A1.344,1.344,0,0,0,74.547,484.788Z",
    transform: "translate(-41.067 -456.043)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.6fb3bf2ea9147b98f9693f51fa428074.svg";
export { ForwardRef as ReactComponent };